import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogEditRequestBody, BlogEditResponse } from "./types";

export class BlogEditAPI extends BaseAPI<
    BlogEditRequestBody,
    BlogEditResponse
> {
    protected route = ApiRoutes.blog.edit;
    protected method = RequestMethod.PUT;
    protected hasFile = true;
    protected params = ["id"]

    protected prepareRequest(data: FormData): RequestInit {
        return {
            method: this.method,
            body: data,
        }
    }
}
